/**
 * Argon page preloader — session skip + bfcache cleanup.
 * Hide timer runs inline in the Liquid snippet so slow page loads
 * never cut the GIF short or delay it until window.load.
 */
(function () {
  if (window.ArgonPagePreloader) return;

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function hasSeen(storageKey) {
    try {
      if (window.sessionStorage && sessionStorage.getItem(storageKey) === '1') {
        return true;
      }
    } catch (e) {}
    return readCookie(storageKey) === '1';
  }

  function cleanup(root) {
    if (root && root.parentNode) {
      root.remove();
    }
    document.documentElement.classList.remove('argon-preloader-active');
    document.documentElement.classList.add('argon-preloader-skip');
  }

  function init() {
    var root = document.getElementById('argon-page-preloader');
    if (!root) return;

    var once = root.getAttribute('data-once-per-session') === 'true';
    var storageKey =
      root.getAttribute('data-storage-key') ||
      'argon_preloader_seen_' + (root.getAttribute('data-page-key') || 'default');

    if (once && hasSeen(storageKey)) {
      cleanup(root);
    }
  }

  window.ArgonPagePreloader = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var root = document.getElementById('argon-page-preloader');
    if (!root) return;
    var once = root.getAttribute('data-once-per-session') === 'true';
    var storageKey =
      root.getAttribute('data-storage-key') ||
      'argon_preloader_seen_' + (root.getAttribute('data-page-key') || 'default');
    if (once && hasSeen(storageKey)) {
      cleanup(root);
    }
  });
})();
